import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22typography.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./font/pretendard/web/variable/woff2/PretendardVariable.woff2%22,%22display%22:%22swap%22,%22weight%22:%2245%20920%22}],%22variableName%22:%22primaryFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'primaryFont', 'primaryFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
